"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketConnector = void 0;
const rxjs_1 = require("rxjs");
class SocketConnector {
    constructor(host) {
        this.rx = new rxjs_1.Subject();
        this.socket = null;
        this.connectedChanges = new rxjs_1.Subject();
        this._connected = false;
        this.host = host;
        this._reconnect();
    }
    get connected() {
        return this._connected;
    }
    get whenConnected() {
        return new Promise((resolve) => {
            if (this.connected) {
                resolve(null);
            }
            else {
                this.connectedChanges
                    .pipe((0, rxjs_1.first)((v) => v))
                    .subscribe((e) => resolve(null));
            }
        });
    }
    send(data) {
        var _a;
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.send(data);
    }
    replaceHost(newHost) {
        this.host = newHost;
        this._reconnect();
    }
    _setConnected(isConnected) {
        if (isConnected !== this._connected) {
            this._connected = isConnected;
            this.connectedChanges.next(this.connected);
        }
    }
    _reconnect() {
        var _a;
        this._setConnected(false);
        (_a = this.socket) === null || _a === void 0 ? void 0 : _a.close();
        this.socket = new WebSocket(this.host);
        this.socket.onopen = (e) => this._setConnected(true);
        this.socket.onclose = (e) => {
            this.socket = null;
            this._setConnected(false);
            setTimeout(() => this._reconnect(), 1000);
        };
        this.socket.onmessage = (event) => this.rx.next(event.data);
    }
}
exports.SocketConnector = SocketConnector;
